import { render, staticRenderFns } from "./commentComponent.vue?vue&type=template&id=c55a59f2&"
import script from "./commentComponent.vue?vue&type=script&lang=js&"
export * from "./commentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports